module.exports = __webpack_public_path__ + "img/workday.e5467782.png";